import { login, logout, setLastError } from "../store/session";
import { useGoogleOneTapLogin } from "react-google-one-tap-login";
import { useAppSelector, useAppDispatch } from "../store";
import Stack from "@mui/material/Stack";
import Item from "@mui/material/Stack";
import LogoutIcon from "@mui/icons-material/Logout";

import { Avatar, Typography } from "@mui/material";
import { backOfficeLogin } from "../model/users";
import axios from "axios";

export const Login = () => {
  const user = useAppSelector((state) => state.session.user);
  const dispatch = useAppDispatch();

  useGoogleOneTapLogin({
    disabled: user !== undefined,
    onError: (error) => {
      console.error('google err', error);
      dispatch(logout());
    },
    googleAccountConfigs: {
      client_id:
        "1034643808583-2cg1jm7sct1lf8svrrt5qtkm3t0touqj.apps.googleusercontent.com",
      cancel_on_tap_outside: true,
      callback: async ({ credential }) => {
        try {
          const response = await backOfficeLogin(credential);
          const {data} = response;
          if (data) dispatch(login(data));
        } catch (e) {
          dispatch(setLastError(String(e)));
        }

      },
    },
  });

  if (!user) {
    // Prevent one tap disappear strategy
    document.cookie =
      "g_state=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  }

  return (
    <>
      {user && (
        <Stack direction={"row"} spacing={2} margin={0.5}>
          {user.picture && (
            <Item>
              <Avatar
                alt={user.email}
                src={user.picture}
                imgProps={{ referrerPolicy: "no-referrer" }}
              />
            </Item>
          )}
          <Item>
            <Stack>
              <Item>
                <Typography variant="body2">{user.name || ""}</Typography>
              </Item>
              <Item>
                <Typography variant="caption" style={{ opacity: 0.7 }}>
                  {user.email}
                </Typography>
              </Item>
            </Stack>
          </Item>
          <Item>
            <LogoutIcon onClick={() => dispatch(logout())} />
          </Item>
        </Stack>
      )}
    </>
  );
};
